import * as React from 'react'

import { BaseEventModel } from 'app/models/baseEventModel'
import { OutOfScopeModel } from 'app/models/outOfScopeModel'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

const color = '#FF6A00'

export type OutOfScopeBlockProps = {
  outOfScope: OutOfScopeModel
  index: number
}

const prepareTooltipInfo = (outOfScope: OutOfScopeModel): BaseEventModel => ({
  startTime: outOfScope.startTime,
  endTime: outOfScope.endTime,
  typeName: 'eventName.outOfScope',
  color,
})

export const OutOfScopeBlock: React.FC<OutOfScopeBlockProps> = React.memo(
  (props: OutOfScopeBlockProps) => {
    const scene = useScene()

    const HEIGHT = scene.height - 28
    const outOfScope = props.outOfScope

    const width = scene.widthOf(outOfScope.startTime, outOfScope.endTime)
    const left = scene.timeToX(outOfScope.startTime)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          position: 'absolute',
          top: 0,
          bottom: 0,
          paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          data-tip={JSON.stringify(prepareTooltipInfo(outOfScope))}
          data-for="eventTooltip"
          style={{
            background: color,
            height: HEIGHT,
            width: width,
            opacity: 0.5,
            pointerEvents: 'auto',
          }}
        />
      </div>
    )
  },
)

OutOfScopeBlock.displayName = 'OutOfScopeBlock'
